import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { StockPurchaseOrderApprovalResponseModel } from '~/models/administration/stockPurchaseOrderApprovalResponseModel';
import { StockPurchaseOrderApprovalsWithUser } from '~/models/administration/stockPurchaseOrderApprovals';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class POApprovalsService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    
    getPurchaseOrderApproval(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);
        
        return this.http
          .post<StockPurchaseOrderApprovalResponseModel[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
          })
          .pipe(map(augmentPaging));
  }


    getStockPurchaseOrderApprovals() {
        return this.http.get<StockPurchaseOrderApprovalsWithUser>(this._url());
    }

    getStockPurchaseOrderApprovalById(id: number) {
        return this.http.get<StockPurchaseOrderApprovalsWithUser>(`${this._url()}/${id}`);
    }

    updateStockPurchaseOrderApproval(model: any, id: number) {
        return this.client.put(`${this._url()}/${id}`, model);
    }

    createStockPurchaseOrderApproval(model: any) {
        return this.client.post(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/StockPurchaseOrderApprovals${v}`);
    }
}
